import React from "../../__compat__/react/main.entry.mjs.mjs";
import { pickComponentCommonProps, pickDataProps, } from "../../interfaces/commonProps.mjs.mjs";
import { useSpacing } from "../../api/spacing/useSpacing.mjs.mjs";
import { StyledListOrdered, StyledListItem, StyledListUnordered, listClassName, } from "./List.styles.mjs.mjs";
export const List = React.forwardRef(function List({ children, variant = 'bullet', textVariant = 'copy1', ...restProps }, ref) {
    const { className, ...restCommonProps } = pickComponentCommonProps(restProps);
    const outerSpacing = useSpacing(restProps);
    const composedProps = {
        children,
        className: `${className} ${listClassName}`,
        outerSpacing,
        textVariant,
        ...restCommonProps,
        ...pickDataProps(restProps),
    };
    switch (variant) {
        case 'decimal':
        case 'lower-alpha':
            return (React.createElement(StyledListOrdered, { ref: ref, variant: variant, ...composedProps }));
        case 'bullet':
        case 'none':
        default:
            return (React.createElement(StyledListUnordered, { ref: ref, variant: variant, ...composedProps }));
    }
});
export const ListItem = React.forwardRef(function ListItem({ children, ...restProps }, ref) {
    return (React.createElement(StyledListItem, { role: "listitem", ref: ref, ...pickComponentCommonProps(restProps), ...pickDataProps(restProps) }, children));
});
//# sourceMappingURL=List.mjs.mjs.map